import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { TextField } from '@totalsoft/rocket-ui';
import { get, set } from '@totalsoft/change-tracking-react';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';

export const FinancialProductRulesEditGeneralDataComponent = ({ canWrite, rule, validation }) => {
  const [t] = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={5}>
        <TextField
          fullWidth
          value={(rule.ruleCode |> get) || ''}
          onChange={rule.ruleCode |> set}
          label={t('FinancialProduct.Details.Rules.Code')}
          error={!isValid(validation.ruleCode)}
          helperText={getErrors(validation.ruleCode)}
          disabled={!canWrite}
          required
        />
      </Grid>
      <Grid item xs={12} sm={5}>
        <TextField
          fullWidth
          value={(rule.ruleDescription |> get) || ''}
          onChange={rule.ruleDescription |> set}
          label={t('FinancialProduct.Details.Rules.Description')}
          disabled={!canWrite}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <FormControlLabel
          control={<Checkbox checked={rule.generalYN |> get} onChange={rule.generalYN |> set |> onCheckBoxChange} />}
          label={t('FinancialProduct.Details.Rules.GeneralYN')}
          disabled={!canWrite}
        />
      </Grid>
    </Grid>
  );
};

FinancialProductRulesEditGeneralDataComponent.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  rule: PropTypes.object.isRequired,
  validation: PropTypes.object.isRequired
};

export default FinancialProductRulesEditGeneralDataComponent;
